export default "__VITE_ASSET__zYr1e5V3__"